module.exports = __webpack_public_path__ + "img/canada.905bf5d.svg";